import React, { useEffect } from "react";

import Dropdown from "react-bootstrap/Dropdown";
import Wrapper from "../Common/FilterWrapper/index";

import { Grid } from "../../components/Grid.components";
import { Boxed } from "../../components/Boxed.components";
import { Input } from "../../components/Input.components";
import { Text } from "../../components/Text.components";
import { Avatar } from "../../components/Avatar.components";
import { Badge } from "../../components/Badge.components";
import { Button } from "../../components/Button.components";
import { Loader } from "../../components/Loader.components";
import { EmptyState } from "../../components/EmptyState.components";
import {
  TableComponent,
  PaginationComponent,
} from "../../components/Table.components";
import {
  PageTitle,
  Icon,
  StyledDrpDown,
  DropDownMenu,
} from "../../components/style";

import { calcViewMode, formatDateTime, truncateText } from '../../utils/utils';
import { USER_TYPE, pageOptions } from '../../utils/constant';
import { Theme } from '../../utils/theme';

import { SwitchComp } from "../../components/Switch.components";
import DeleteRequestForm from "./DeleteRequestForm/index";
import ChangeRequestStatus from "./ChangeRequestStatus/index";

export const RequestForms = (props) => {
  // state props
  const {
    isLoading,
    contentList,
    contentTotal,
    fetchActionURL,
    deleteRequestModal,
    changeRequestModal,
    profile,
    accessList
  } = props;

  // dispatch props
  const { getList, openCreateModal, redirect, openDeleteModal, getSingleForm, openChangeModal } =
    props;

  useEffect(() => {
    let data = {
      page: 1,
      size: 10,
    };
    getList(data);
  }, []);

  const dropdownList = [
    // { label: "Edit Config", key: 1 },
    { label: 'Delete', key: 2, permission: [USER_TYPE?.ACCOUNT_DIRECTOR] },
    {
      label: 'Deactivate',
      key: 3,
      permission: [USER_TYPE?.ADMINSTRATOR, USER_TYPE?.ACCOUNT_DIRECTOR]
    }
  ];

  const handleDropDown = (item, record) => {
    getSingleForm(record);
    switch (item.key) {
      case 1:
        redirect('/requests/edit')
        break;
      case 2:
        openDeleteModal();
        break;
      case 3:
        openChangeModal();
        break;
      default:
        break;
    }
  };

  const RequestFormCard = ({ data }) => {
    // let newList = dropdownList.filter((item) => {
    //   if (item?.permission?.length < 1) {
    //     return true;
    //   }
    //   if (item.permission.includes(profile?.userType?.description)) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // });
    return (
      <Boxed
        pad="15px"
        borderRadius={Theme.PrimaryRadius}
        background={Theme.TertiaryDark}
        boxShadow={Theme.boxShadow}
        height="100%"
      >
        <Grid desktop="auto 15px" tablet="auto 15px" mobile="auto 15px">
          <Text
            fontWeight="600"
            cursor="pointer"
            onClick={() => console.log(data._id)}
          >
            {data?.title}
          </Text>
          <DropDownMenu
            // list={dropdownList}
            list={[
              { label: "Edit", key: 1, permission: [USER_TYPE?.ADMINSTRATOR, USER_TYPE?.ACCOUNT_DIRECTOR] },
              { label: "Delete", key: 2, permission: [USER_TYPE?.ACCOUNT_DIRECTOR]},
              {
                label: `${
                  data?.status === "active" ? "Deactivate" : "Activate"
                }`,
                key: 3,
                permission: [USER_TYPE?.ADMINSTRATOR, USER_TYPE?.ACCOUNT_DIRECTOR]
              },
            ]}
            handleAction={(value) => handleDropDown(value, data)}
          />
        </Grid>
        <Text
          padding="5px 0"
          color={Theme.SecondaryTextColor}
          fontSize={Theme.SecondaryFontSize}
        >
          {data?.description && truncateText(data?.description, 80)}
        </Text>
        <Text padding="5px 0" fontSize={Theme.SecondaryFontSize}>
          {' '}
          <span>{data?.fields?.length ?? 0}</span> Fields, <span>{data?.steps?.length ?? 0}</span>{' '}
          Steps,{' '}
          {data?.status === 'active' ? (
            <Badge color={Theme.PrimaryGreen}>Active</Badge>
          ) : (
            <Badge color={Theme.PrimaryRed}>Inactive</Badge>
          )}
        </Text>
        <Text padding="5px 0" fontSize={Theme.SecondaryFontSize}>
          Created on {data?.createdAt ? formatDateTime(data?.createdAt) : null} by{' '}
          <span style={{ cursor: 'pointer', color: Theme.PrimaryColor }}>
            {data?.createdBy?.lastName} {data?.createdBy?.firstName}{' '}
          </span>
        </Text>
      </Boxed>
    );
  };

  return (
    <>
      <Boxed pad="20px">
        <PageTitle>Request Configuration</PageTitle>
        <Boxed pad="20px 10px">
          <Wrapper
            externalActionURL={fetchActionURL}
            render={({
              changePageSize,
              handlePagination,
              currentPage,
              pageSize,
              search,
            }) => {
              return (
                <>
                  <Grid
                    desktop="repeat(4, 1fr)"
                    tablet="repeat(4, 1fr)"
                    mobile="repeat(1, 1fr)"
                  >
                    <Boxed pad="5px 0">
                      <Input
                        type="search"
                        placeholder="Search..."
                        onChange={(value) => search(value, fetchActionURL)}
                      />
                    </Boxed>
                    <Boxed />
                    <Boxed />
                    <Boxed pad="5px 0" align="right">
                      <Button onClick={() => redirect('/requests/create')}>Add Request Form</Button>
                    </Boxed>
                  </Grid>
                  {isLoading ? (
                    <Boxed display="flex" pad="20px">
                      <Loader margin="auto" />
                    </Boxed>
                  ) : (
                    <>
                      {" "}
                      {contentTotal > 0 ? (
                        <>
                          <Grid
                            desktop="repeat(4, 1fr)"
                            tablet="repeat(4, 1fr)"
                            mobile="repeat(1, 1fr)"
                            pad="20px 0"
                          >
                            {contentList?.map((item, index) => {
                              return (
                                <Boxed pad="2.5px" key={index}>
                                  <RequestFormCard data={item} />
                                </Boxed>
                              );
                            })}
                          </Grid>

                          <Boxed pad="10px 0 ">
                            <PaginationComponent
                              total={contentTotal}
                              onChange={(page) =>
                                handlePagination(page, fetchActionURL)
                              }
                              current={currentPage}
                              pageCounts={pageOptions}
                              changePageSize={(pageSize) =>
                                changePageSize(pageSize, fetchActionURL)
                              }
                              pageSize={pageSize}
                              itemsDisplayed
                              showTotal={(total, range) => {
                                return `${range[0]} - ${range[1]} of ${contentTotal} items`;
                              }}
                            />
                          </Boxed>
                        </>
                      ) : (
                        <EmptyState />
                      )}
                    </>
                  )}
                </>
              );
            }}
          />
        </Boxed>
      </Boxed>
      {deleteRequestModal && <DeleteRequestForm />}
      {changeRequestModal && <ChangeRequestStatus  />}
    </>
  );
};
